<template>
  <div class="design_2_block">
    <div class="box">
      <h1 class="h1_first">Выбор направления</h1>
      <div class="row">
        <div class="col-md-4" v-for="(data, index) of this.designData.cart" :key="index">
          <div class="cart">
            <div class="img_background img_background_1" :style="'background:url(' + require(`@/assets/img/design/${data.img_cart}`) + ') center center / cover no-repeat'">
              <p class="p_img">{{data.cart_tittle}}</p>
            </div>
            <div class="under_cart">
              <div class="inside_cart_line"></div>
              <p class="text_inside_cart">{{data.cart_desc}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex';
import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
  name:'',
  components: {
  },
  data(){
    return{
      id: this.$route.query.info || 1,
    }
  },

  watch:{
    // designData(){
    //   window.scrollTo(
    //     {
    //       top:0,
    //     })
    //   }
  },

  mounted(){
    this.$store.state.design_id = this.id
    
  },
  created(){
    
  },
  methods:{
    update(){
      this.id = Number.parseInt(to.query.info) || 1
    },
    ...mapMutations({
      FEEDBACK_FORM:'FEEDBACK_FORM',
  }),
  ...mapActions({
  }),
  },
  computed:{
    ...mapGetters([
      'DESIGN_DATA',
  ]),
    designData:function(){
      return this.DESIGN_DATA
    }
  } 
};
</script>

<style scoped>
.text_inside_cart {
  font-size:15px;
  margin:10px 0 0 0;
}
.inside_cart_line {
  background:#5245E8;
  width:30%;
  height:4px;
}
.under_cart {
  width:100%;
  height: auto;
  padding:20px;
  background:#fff;
  border-radius:0 0 20px 20px;
}
.p_img {
  color:#000;
  background:#fff;
  border-radius:20px;
  padding:3px 10px;
  position:absolute;
  margin:28px 0 0 35px;
  font-size:14px;
  font-weight:600;
}
.img_background_1 {

  background-size: cover;
  background-position: center;
}
.img_background_2 {

  background-size: cover;
  background-position: center;
}
.img_background_3 {

  background-size: cover;
  background-position: center;
}
.img_background {
  width:100%;
  height:328px;
  border-radius:20px 20px 0 0;
}
.cart {
  width:auto;
  height:100%;
}
.h1_first {
  margin:0 0 40px 0;
  font-size:30px;
  color:#fff;
}
.box {
  max-width: 1262px;
  margin-left: auto;
  margin-right: auto;
  padding: 0 15px 0 15px;
}
@media(max-width:767px) {
  .cart {
    margin-top:15px;
  }
  .h1_first {
    font-size:25px;
  }
}
@media 
</style>